import { render } from "./RollerView.vue?vue&type=template&id=a8828508"
import script from "./RollerView.vue?vue&type=script&lang=js"
export * from "./RollerView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__